var _rect, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 26,
    viewBox: "0 0 18.521 6.8792",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.83296 0 0 .79913 15.687 -62.176)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -18.833,
    y: 77.804,
    width: 22.235,
    height: 8.6083,
    ry: 2.0967,
    fill: "#abb0b4"
  })), /*#__PURE__*/React.createElement("text", {
    x: -15.54788,
    y: 83.435272,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "3.712px",
    letterSpacing: "0px",
    strokeWidth: 0.092802,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -15.54788,
    y: 83.435272,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontWeight: "bold",
    strokeWidth: 0.092802
  }, "OFFLINE")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusOffline);
export default __webpack_public_path__ + "static/media/status_offline.364537e168f294d440d0d9741ac9e8a0.svg";
export { ForwardRef as ReactComponent };